import React, { useState, useEffect } from "react";
import "./BillwiseReport.css";   // reuse same styling

export default function ItemwiseReport({fromDate,toDate}) {



  const [reportData, setReportData] = useState([]);
  const [totalQty, setTotalQty] = useState(0);
  const [totalKgs, setTotalKgs] = useState(0);

  // ================= AUTO LOAD =================
  useEffect(() => {
    if (fromDate && toDate) {
      fetchReport();
    }
  }, [fromDate, toDate]);

  const fetchReport = async () => {
    try {

      const res = await fetch(
        `/api/deliveries/itemwise?from=${fromDate}&to=${toDate}`
      );

      const data = await res.json();

      setReportData(data);

      const qtySum = data.reduce(
        (sum, row) => sum + Number(row.totalQty || 0),
        0
      );

      const kgsSum = data.reduce(
        (sum, row) => sum + Number(row.totalKgs || 0),
        0
      );

      setTotalQty(qtySum);
      setTotalKgs(kgsSum);

    } catch (err) {
      console.error("Itemwise fetch error:", err);
    }
  };

  // ================= PRINT =================
  const handlePrint = () => {

    const printWindow = window.open("", "_blank");

    printWindow.document.write(`
      <html>
      <head>
        <title>Itemwise Report</title>
        <style>
          body { font-family: Arial; padding: 20px; }

          .report-wrapper {
            border: 2px solid #000;
            padding: 10px;
          }

         .header-section {
  position: relative;
  margin: -10px -10px 15px -10px;   /* extend to wrapper border */
  border-bottom: 2px solid #000;
  padding: 10px 10px 10px 10px;
}

          .company-section { text-align: center; }

          .title { font-size: 20px; font-weight: bold; }
          .sub-title { font-size: 14px; }

          .date-section {
            position: absolute;
            right: 0;
            top: 0;
            text-align: right;
            font-weight: bold;
            font-size: 14px;
          }

          table {
            width: 100%;
            border-collapse: collapse;
          }

          th, td {
            border: 1px solid #000;
            padding: 6px;
            font-size: 14px;
            text-align: center;
          }

          th { background: #eaeaea; }

          tfoot td { font-weight: bold; }

        </style>
      </head>

      <body>

        <div class="report-wrapper">

          <div class="header-section">

            <div class="company-section">
              <div class="title">ORANGE TRADINGS</div>
              <div class="sub-title">DHARAPURAM ROAD, TIRUPUR - 641 601</div>
            </div>

            <div class="date-section">
              <div>From Date : ${fromDate}</div>
              <div>To Date&nbsp;&nbsp;&nbsp;: ${toDate}</div>
            </div>

          </div>

          <table>
            <thead>
              <tr>
                <th>Item Name</th>
                <th>Total Qty</th>
                <th>Total Kgs</th>
              </tr>
            </thead>

            <tbody>
              ${reportData.map(row => `
                <tr>
                  <td>${row.itemName}</td>
                  <td>${row.totalQty}</td>
                 <td>${row.totalKgs} ${row.unitType}</td>
                </tr>
              `).join("")}
            </tbody>

            <tfoot>
              <tr>
                <td>Total</td>
                <td>${Number(totalQty).toFixed(2)}</td>
                <td>${Number(totalKgs).toFixed(2)}</td>
              </tr>
            </tfoot>

          </table>

        </div>

      </body>
      </html>
    `);

    printWindow.document.close();

    printWindow.onload = function () {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    };
  };

  // ================= UI =================
  return (
    <div className="billwise-container">

      

      {/* Table Section */}
      <div className="billwise-table-section">

        <div className="billwise-table-wrapper">
          <table className="billwise-table">

            <thead>
              <tr>
                <th>Item Name</th>
                <th>Total Qty</th>
                <th>U/A</th>
              </tr>
            </thead>

            <tbody>
              {reportData.length > 0 ? (
                reportData.map((row, index) => (
                  <tr key={index}>
                    <td>{row.itemName}</td>
                    <td>{row.totalQty}</td>
                    <td>{row.totalKgs} {row.unitType}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="no-data">
                    No data found
                  </td>
                </tr>
              )}
            </tbody>

          </table>
        </div>

      <div className="del-summary">

  <div className="del-summary-row">

    <div className="summary-field total">
      <label>Total Qty</label>
      <input value={Number(totalQty).toFixed(2)} readOnly />
    </div>

    <div className="summary-field total">
      <label>Total U/A</label>
      <input value={Number(totalKgs).toFixed(2)} readOnly />
    </div>

  </div>

</div>

        <div className="billwise-buttons">
          <button onClick={handlePrint}>Print</button>
        </div>

      </div>

    </div>
  );
}
